import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import {
  server_post_data,
  login_to_admin,
} from "../ServiceConnection/serviceconnection.js";
import { storeData } from "../LocalConnection/LocalConnection.js";
import { useAuth } from "../contexts/AuthContext"; // ← add

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth(); // ← add

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Email and password are required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const formData = new FormData();
      formData.append("useremail", email);
      formData.append("userpassword", password);

      const response = (await server_post_data(login_to_admin, formData)).data;

      if (response?.error === false) {
        const resData = response.message;

        storeData("access_token", resData.tokens.access);
        storeData("refresh_token", resData.tokens.refresh);
        storeData("admin_id", resData.data_admin.primary_id);
        storeData("admin_name", resData.data_admin.admin_name ?? "");
        storeData("admin_email", resData.data_admin.admin_email ?? "");
        storeData("admin_mobile", resData.data_admin.admin_mobile_no ?? "");
        storeData(
          "designation_name",
          resData.data_designation?.designation_name ?? "",
        );

        login();
        window.location.href = "/dashboard";
      } else {
        setError(response?.message || "Invalid credentials");
      }
    } catch (err) {
      console.error("CATCH ERROR 👉", err);
      setError("Server error. Try again later.");
    }

    setLoading(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-purple-600 text-3xl">
            🎪
          </div>
          <h1 className="text-3xl font-bold text-gray-900">Fun City</h1>
          <p className="mt-1 text-gray-500">
            Admin Panel — Billing & Ticketing
          </p>
        </div>

        <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-lg">
          <h2 className="mb-1 text-center text-xl font-bold text-gray-900">
            Admin Login
          </h2>
          <p className="mb-6 text-center text-sm text-gray-500">
            Enter your credentials to continue
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                placeholder="Enter admin email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError("");
                }}
                className="w-full rounded-xl border border-gray-200 px-4 py-3 text-sm outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500"
              />
            </div>

            <div>
              <label className="mb-1.5 block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                type="password"
                placeholder="Enter admin password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                className="w-full rounded-xl border border-gray-200 px-4 py-3 text-sm outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500"
              />
              {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full rounded-xl py-3 text-sm font-semibold text-white transition-colors ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-purple-600 hover:bg-purple-700"
              }`}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </div>

        <div className="mt-6 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700"
          >
            <ArrowLeft size={14} /> Back to Website
          </Link>
        </div>
      </div>
    </div>
  );
}
